module.exports = __webpack_public_path__ + "static/media/my_card_icon_active.6144dd36.svg";